import merge from 'lodash/merge'
import es from '../es'
import ar from '../es-AR'
import tableroSeleccion from './tablero-seleccion.json'
import talentPool from './talent-pool.json'
import currencyMask from './currency-mask.json'
import homePage from './home-page.json'
import hunter from './hunter.json'
import productos from './productos.json'
import signUp from './sign-up.json'
import avisoPublicacion from './aviso-publicacion.json'
import avisoProductos from './aviso-productos.json'
import ecommerce from './ecommerce.json'
import statistics from './statistics.json'

const zjAr = {
  ...es,
  ...ar,
  pageTitle: 'Portal para empresas - {{nombreSitio}}',
  tableroSeleccion: merge({}, ar.tableroSeleccion, tableroSeleccion),
  talentPool: merge({}, ar.talentPool, talentPool),
  homePage: merge({}, ar.homePage, homePage),
  currencyMask,
  hunter: merge({}, ar.hunter, hunter),
  productos: merge({}, ar.productos, productos),
  signUp: merge({}, ar.signUp, signUp),
  avisoPublicacion: merge({}, ar.avisoPublicacion, avisoPublicacion),
  avisoProductos: merge({}, ar.avisoProductos, avisoProductos),
  ecommerce,
  statistics: merge({}, es.statistics, statistics),
}

export default zjAr
